import { NgModule } from "@angular/core";
import {
  CardRewardComponent,
  CardRewardsBlockComponent,
  IssuePointsAdditionalDetailsComponent,
  LoyaltyCardComponent,
  LoyaltyCardsComponent
} from "@app-cmc/features/issue-points";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  LoyaltyProgramBalanceComponent,
  LoyaltyProgramRewardsComponent,
  MaxLengthDirective,
  QrCodeReaderButtonComponent
} from "clearline-common";
import { SimplebarAngularModule } from "simplebar-angular";
import { CommonFeatureModule } from "../common/common-feature.module";
import { IssuePointsModalComponent } from "./issue-points-modal";
import { FormatLoyaltyCardUserDetailsPipe } from "./pipes";

@NgModule({
  declarations: [
    FormatLoyaltyCardUserDetailsPipe,
    IssuePointsModalComponent,
    LoyaltyCardsComponent,
    LoyaltyCardComponent,
    IssuePointsAdditionalDetailsComponent,
    CardRewardsBlockComponent,
    CardRewardComponent
  ],
  imports: [
    CommonFeatureModule,
    NgSelectModule,
    SimplebarAngularModule,
    MaxLengthDirective,
    QrCodeReaderButtonComponent,
    LoyaltyProgramRewardsComponent,
    LoyaltyProgramBalanceComponent
  ],
  exports: [IssuePointsModalComponent]
})
export class IssuePointsModule {}
